<template>
    <el-dialog
        title="分享"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
    <el-scrollbar style="100%">
        <div class="dialogBody">
            <div class="qrcodeBox" id="qrcode" v-for="(item,index) in qrcodeImgArr" :key="index">
                <img :src="item.url" alt="">
                <p>{{item.name}}</p>
                <div @click="downLiadQrImg" class="btn">下载</div>
            </div>
        </div>
    </el-scrollbar>
    </el-dialog>
</template>
<script>
import {getClassDetails} from '@/api/measApi/teachManagement.js'
import { urlToQRCode } from '@/assets/measAssets/js/tools.js'
export default {
    data(){
        return {
            dialogVisible: false,
            params: {
                code: 0,
                isonlyclassinfo: true
            },
            qrcodeImg: '',
            imgUrl: '',
            qrcodeImgArr: []
        }
    },
    methods: {
        init(row){
            this.dialogVisible = true
            this.qrcodeImgArr = []
            this.qrcodeImg = row.studentsysdomain+ ''
            if(row.code){
                this.params.code = row.code
                this.getClassDetails()
            }
        },
        handleClose(){
            this.dialogVisible = false
        },
        getClassDetails(){
            getClassDetails(this.params).then(res => {
                // console.log(res.data,'ssssssss')
                let codeArr = res.data.classdetails.campuscode.split(',')
                let nameArr = res.data.classdetails.campusname.split(',')
                nameArr.forEach((item,index) => {
                    this.qrcodeImgArr.push({
                        name: item,
                        code: codeArr[index],
                        url: urlToQRCode(this.qrcodeImg + '/m/signUp/classIntro' +'?classcode='+this.params.code+'&campuscode='+codeArr[index])
                    })
                });

                console.log(this.qrcodeImgArr,'this.qrcodeImgArr')
            })
        },
        downLiadQrImg(){
            try {
                let qrcode = document.getElementById('qrcode');
                let img = qrcode.getElementsByTagName('img')[0];
                this.imgUrl = img.getAttribute("src");
                let link = document.createElement("a");
                link.setAttribute("href", this.imgUrl);
                link.setAttribute("download", '二维码.png')
                link.click();
                this.$message.success('下载成功')
            } catch (error) {
                this.$message.error('下载出错')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.dialogBody{
    display: flex;
    align-items: center;
    max-height: 600px;
    // justify-content: center;
    flex-wrap: wrap;
    .qrcodeBox{
        text-align: center;
        padding-top: 20px;
        margin: 0 22px;
        img{
            width: 100px;
            height: 100px;
        }
        p{
            font-size: 12px;
            color: #333333;
            margin: 20px 0;
        }
        .btn{
            width: 108px;
            height: 32px;
            background: #0B75FA;
            font-size: 14px;
            border-radius: 4px;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }
}
</style>